export function formatDate(date) {
  const selectedDate = new Date(date);

  return (
    selectedDate.getFullYear() +
    "-" +
    parseInt(selectedDate.getMonth() + 1) +
    "-" +
    selectedDate.getDate()
  );
}
